import * as React from 'react'
import { styles } from './styles.css'

type Props = {
  id?: string
  title?: string
  subtitle?: string
  className?: string
  children: React.ReactNode
  ref?: React.RefObject<HTMLElement>
}

const Section: React.FC<Props> = ({ id, title, subtitle, className, children, ref }) => {
  return (
    <section id={id} className={`${styles.section} ${className}`} ref={ref}>
      {title && subtitle ? (
        <div>
          <h2 className={styles.title}>{title}</h2>
          <p className={styles.subtitle}>{subtitle}</p>
        </div>
      ) : null}
      <div>{children}</div>
    </section>
  )
}

export { Section }
